import {
  UNIT,
  USER,
  ROLES,
  CONFIG,
  SEGMENTATIONS,
  CONSTRUCTION_STAGE,
} from '../../utils/constants';
import { getItem, setItem } from '../../services/storage';
import { contractIsActive } from '../../utils';
import bus from '@/utils/bus';
import requestService from '../../services/request';
import enums from '@/utils/enums';
import logTrace from '@/services/logTrace';
import i18n from '@/lang';
import moment from 'moment-timezone';
const promisesCache = {};

const formatDetachedType = (arr) =>
  Array.isArray(arr) ? arr.map((o) => o.replace(/\s|\./g, '-')) : [];

const formatObjectuUndefined = (data) => {
  let logs = [];
  for (var [key, value] of Object.entries(data)) {
    if (value === undefined) {
      logs.push({
        ...data,
        key,
        value,
      });

      data[key] = null;
    }
  }

  if (logs.length > 0) {
    logTrace({
      action: enums.logTraceActions.controlledLogError,
      details: {
        Errors: {
          logs,
          date: moment(),
          description: 'segmentedHome undefined Object',
        },
      },
    });
  }
};

export default {
  state: {
    units: getItem('units') || [],
    unit: getItem('unit') || null,
    product: null,
    productDetails: null,
    unitSegmentations: [],
    productPromise: null,
  },
  getters: {
    [UNIT.GET_ALL]: (state) => state.units,
    [UNIT.GET_SELECTED]: (state) => state.unit,
    [UNIT.GET_SELECTED_PRODUCT]: (state) => state.product,
    [UNIT.GET_SELECTED_PRODUCT_DETAILS]: (state) => state.productDetails || {},
    [UNIT.GET_DISCOUNT_LIST]: (state, getters) => {
      if (
        getters[UNIT.GET_SELECTED_PRODUCT_DETAILS]
          .discountKeyDeliveryRequired &&
        !getters[UNIT.GET_SELECTED].keyDeliveryDate
      ) {
        return [];
      }
      return (
        getters[UNIT.GET_SELECTED_PRODUCT_DETAILS].discounts
          ? getters[UNIT.GET_SELECTED_PRODUCT_DETAILS]
          : {
              discounts: [],
            }
      ).discounts.filter((discount) => discount.active);
    },
    [UNIT.GET_CONCLUSION_CERTIFICATE_DATE]: (state) =>
      state.unit && state.unit.block
        ? state.unit.block.conclusionCertificateDate
        : null,
    [UNIT.GET_SEGMENTATIONS]: (state) => state.unitSegmentations,
    [UNIT.GET_IS_SETTLED]: (state) =>
      state.unitSegmentations.includes(SEGMENTATIONS.SETTLED__REHEARSE_STATUS),
    [UNIT.GET_IS_INDIRECT]: (state) =>
      state.unitSegmentations.length > 0
        ? state.unitSegmentations.includes(SEGMENTATIONS.INDIRECT__USER_ROLE)
        : undefined,
    [UNIT.GET_IS_SYNDIC]: (state, getters) =>
      getters[USER.GET_USER_ROLE] === ROLES.SYNDIC_ROLE,
    [UNIT.GET_IS_KEY_DELIVERED]: (state) =>
      state.unitSegmentations.length > 0
        ? state.unitSegmentations.includes(
            SEGMENTATIONS.KEYS_DELIVERED__CONSTRUCTION_STAGE
          )
        : undefined,
    [UNIT.GET_DEBIT_BLOCK]: (state) =>
      !!state.unit.contracts.some((contract) => contract.debitBlock),
    [UNIT.GET_SHOW_IN_CONSTRUCTION]: (state) =>
      state.unitSegmentations.includes(
        enums.constuctionStageSegmentation['inConstruction']
      ),
    [UNIT.GET_SHOW_DECORATED]: (state, getters) => {
      var segmentations = null;
      const product = getters[UNIT.GET_SELECTED_PRODUCT];
      if (product) {
        const constructionStage = enums.constuctionStages[product.stage];
        switch (constructionStage) {
          case 'launch':
            segmentations = null;
            break;
          case 'inConstruction':
            segmentations = null;
            break;
          case 'delivered':
            if (getters[UNIT.GET_IS_KEY_DELIVERED]) {
              segmentations = [
                SEGMENTATIONS.ASSOCIATIVE__REHEARSE_STATUS,
                SEGMENTATIONS.ASSOCIATIVE_REHEARSED__REHEARSE_STATUS,
                SEGMENTATIONS.SFH__REHEARSE_STATUS,
                SEGMENTATIONS.SETTLED__REHEARSE_STATUS,
                SEGMENTATIONS.INDIRECT__USER_ROLE,
                SEGMENTATIONS.DIRECT__REHEARSE_STATUS,
                SEGMENTATIONS.KEYS_DELIVERED__CONSTRUCTION_STAGE,
              ];
            } else {
              segmentations = [
                SEGMENTATIONS.ASSOCIATIVE_REHEARSED__REHEARSE_STATUS,
                SEGMENTATIONS.SETTLED__REHEARSE_STATUS,
                SEGMENTATIONS.INDIRECT__USER_ROLE,
                SEGMENTATIONS.DIRECT__REHEARSE_STATUS,
                SEGMENTATIONS.DELIVERED__CONSTRUCTION_STAGE,
              ];
            }
            break;
        }
      }
      if (Array.isArray(segmentations)) {
        if (segmentations.length > 0) {
          const unitSegmentations = getters[UNIT.GET_SEGMENTATIONS];
          return unitSegmentations.every((segmentation) =>
            segmentations.includes(segmentation)
          );
        }
      } else {
        // null or undefined
        return false;
      }
    },

    [UNIT.SYNDIC_MAINTENANCE_LINK]: (state) => {
      const syndicLinks =
        state.productDetails && state.productDetails.links
          ? state.productDetails.links.syndicLinks
          : null;

      if (syndicLinks) {
        const link = syndicLinks.find((link) => link.sku === state.unit.sku);
        return link ? link.maintenanceControlUrl : null;
      } else {
        return null;
      }
    },
    [UNIT.SYNDIC_MANUAL_LINK]: (state) => {
      const syndicLinks =
        state.productDetails && state.productDetails.links
          ? state.productDetails.links.syndicLinks
          : null;

      if (syndicLinks) {
        const link = syndicLinks.find((link) => link.sku === state.unit.sku);
        return link ? link.syndicManualUrl : null;
      } else {
        return null;
      }
    },
  },
  mutations: {
    [UNIT.SET]: (state, payload) =>
      (state.unit = {
        ...payload,
      }),
    [UNIT.MUTATE]: (state, payload) => {
      let units = [];
      const byHash = {};
      const byId = [];
      for (const contract of payload) {
        // syndic does not have unit
        const newId = contract.sku || contract.unit;
        const unitCodeClean = contract.unit.code.replace(/p/i, '');
        if (!byHash[newId]) {
          byHash[newId] = {
            sku: contract.sku,
            product: {
              id: contract.product.id,
              title: contract.product.title,
              code: contract.product.code,
            },
            block: {
              id: contract.block.id,
              title: contract.block.title,
              code: contract.block.code,
            },
            unit: {
              id: contract.unit.id,
              code: contract.unit.code,
            },
            unitCodeClean,
            keyDeliveryDate: contract.keyDeliveryDate,
            financialModality: contract.financialModality,
            isRehearseReleased: contract.isRehearseReleased,
            isRehearseFinished: contract.isRehearseFinished,
            isSettled: contract.isSettled,
            contracts: [],
          };
          byId.push(newId);
        }

        const item = {
          type: contract.type,
          detachedType: formatDetachedType(contract.detachedType),
          id: contract.contractId,
          proposers: contract.proposers || [],
          debitBlock: contract.debitBlock,
          contractedAt: contract.contractedAt,
          contractedDataBase: contract.contractedDataBase,
          status: contract.status,
          isValid: contract.isValid,
          isSettled: contract.isSettled,
          keyDeliveryDate: contract.keyDeliveryDate,
          financialModality: contract.financialModality,
          isRehearseReleased: contract.isRehearseReleased,
          isRehearseFinished: contract.isRehearseFinished,
        };

        const operation = item.isValid ? 'unshift' : 'push';

        byHash[newId].contracts[operation](item);
      }
      for (const id of byId) {
        let unitObj = byHash[id];
        const product = state.product;
        if (product && unitObj.product.id == product.externalSourceId) {
          const foundBlock = product.blocks.find(
            (block) => block.id === unitObj.block.id
          );
          if (foundBlock != null) {
            unitObj.block.conclusionCertificateDate =
              foundBlock.conclusionCertificateDate;
          }
        }
        if (unitObj.contracts.find((contract) => contract.isValid)) {
          units.push(unitObj);
        }
      }
      state.units = units;

      if (state.unit) {
        state.unit = state.units.find((o) => o.sku === state.unit.sku) || null;
      }

      bus.$emit('unit:update', state.unit);
      setItem('units', units);
    },
    [UNIT.PRODUCT_MUTATE]: (state, payload) => {
      state.product = payload;
    },
    [UNIT.PRODUCT_DETAILS_MUTATE]: (state, payload) => {
      state.productDetails = payload;
    },
    [UNIT.UNIT_SEGMENTATIONS_MUTATE]: (state, payload) => {
      state.unitSegmentations = payload;
    },
    [UNIT.SYNDIC_MAINTENANCE_LINK]: (state, payload) => {
      const data = moment();
      const productId = state.unit.product.id;
      const month = moment().month() + 1;
      const day = moment().date();

      const verific1 = 4 * productId + 2 * month + 4 * day;
      const verific2 = Math.abs(2 * productId - 5 * day - 6 * month);
      const verific3 = Math.abs(5 * productId - 4 * month + 4 * day);
      const verific4 = Math.abs(3 * productId + 7 * day - 5 * month);
      const validationCode = `${verific1}${month}${verific2}${verific3}${day}${verific4}`;

      const syndicLinks =
        state.productDetails && state.productDetails.links
          ? state.productDetails.links.syndicLinks
          : null;

      if (syndicLinks) {
        const link = syndicLinks.find((link) => link.sku === state.unit.sku);
        const maintenanceControlUrl = link.maintenanceControlUrl;
        const form = document.createElement('form');

        form.setAttribute('method', 'post');
        form.setAttribute('action', maintenanceControlUrl);
        form.setAttribute('target', '_blank');

        const inputs = {
          num_emp: productId,
          cod: validationCode,
        };

        for (const key in inputs) {
          const value = inputs[key];

          const inputUnit = document.createElement('input');
          inputUnit.setAttribute('name', key);
          inputUnit.setAttribute('value', value);
          inputUnit.setAttribute('type', 'hidden');
          form.appendChild(inputUnit);
        }

        document.body.appendChild(form);
        form.submit();

        return link ? link.maintenanceControlUrl : null;
      } else {
        return null;
      }
    },
  },
  actions: {
    [UNIT.SELECT]: async ({ state, getters, commit, dispatch }, unitObj) => {
      let unitChanged = state.unit && unitObj && state.unit.sku != unitObj.sku;
      commit(UNIT.SET, unitObj);
      setItem('unit', unitObj);

      const promises = [
        dispatch(UNIT.FETCH_PRODUCT, unitChanged),
        dispatch(UNIT.FETCH_PRODUCT_DETAILS, unitChanged),
      ];
      const [product] = await Promise.all(promises);

      if (
        unitObj &&
        product &&
        unitObj.product.id == product.externalSourceId
      ) {
        const foundBlock = getters[UNIT.GET_IS_SYNDIC]
          ? product.blocks.find(
              (block) => block.conclusionCertificateDate != null
            )
          : product.blocks.find((block) => block.id === unitObj.block.id);

        if (foundBlock != null) {
          if (
            unitObj.block.conclusionCertificateDate !=
            foundBlock.conclusionCertificateDate
          ) {
            unitObj.block.conclusionCertificateDate =
              foundBlock.conclusionCertificateDate;
            unitChanged = true;
            commit(UNIT.SET, unitObj);
          }
        }
      }
      if (unitChanged) {
        bus.$emit('unit:change', state.unit);
      }
    },

    [UNIT.FETCH_PRODUCT]: async (
      { state, getters, commit, dispatch },
      unitChanged
    ) => {
      let product = null;
      const unitObj = state.unit;
      if (unitObj && unitObj.product) {
        const code = unitObj.product.code;
        const externalSourceId = unitObj.product.id;
        product = state.product;
        if (state.productPromise) {
          let result = await state.productPromise;
          product =
            result.items && result.items.length > 0 ? result.items[0] : null;
        }
        if (
          !unitChanged &&
          product &&
          product.code == code &&
          product.externalSourceId == externalSourceId
        ) {
          product = state.product;
        } else {
          commit(UNIT.UNIT_SEGMENTATIONS_MUTATE, []);
          const params = {
            filter: {
              code,
              externalSourceId,
            },
            desiredFields: {
              title: 1,
              institutionalPath: 1,
              code: 1,
              externalSourceId: 1,
              tourUrl: 1,
              status: 1,
              lastUpdate: 1,
              externalLastUpdate: 1,
              stage: 1,
              address: 1,
              nameSPE: 1,
              cnpjSPE: 1,
              'blocks.id': 1,
              'blocks.conclusionCertificateDate': 1,
              'blocks.type': 1,
            },
          };
          const url = `${process.env.CRUD_API_GET}/product`;
          if (!state.productPromise) {
            state.productPromise = requestService(url, 'GET', {
              params,
            });
          }
          let result = await state.productPromise;
          product =
            result.items && result.items.length > 0 ? result.items[0] : null;
          state.productPromise = null;
          if (!product) {
            const urlImportProduct = `${process.env.IMPORT_PRODUCTS_URL}`;
            const { product: importedProduct, message } = await requestService(
              urlImportProduct,
              'POST',
              {
                data: {
                  productCode: code,
                  productId: externalSourceId,
                },
              }
            );
            if (message && message.includes('importation successful')) {
              product = importedProduct;
            }
          }

          const unitContract = unitObj.contracts.find(contractIsActive);

          const unitSegmentations = [];
          let constructionStage = null;

          if (getters[USER.GET_USER_ROLE] === ROLES.SYNDIC_ROLE) {
            unitSegmentations.push(SEGMENTATIONS.SYNDIC__USER_ROLE);
          } else if (unitContract) {
            if (unitContract.type === 'Indireto') {
              unitSegmentations.push(SEGMENTATIONS.INDIRECT__USER_ROLE);
            } else if (unitContract.isSettled) {
              unitSegmentations.push(SEGMENTATIONS.SETTLED__REHEARSE_STATUS);
            } else {
              if (unitContract.isRehearseFinished) {
                unitSegmentations.push(
                  SEGMENTATIONS.ASSOCIATIVE_REHEARSED__REHEARSE_STATUS
                );
              } else {
                switch (unitContract.financialModality) {
                  case 'SFH':
                    unitSegmentations.push(SEGMENTATIONS.SFH__REHEARSE_STATUS);
                    break;
                  case 'ASSOCIATIVO':
                    unitSegmentations.push(
                      SEGMENTATIONS.ASSOCIATIVE__REHEARSE_STATUS
                    );
                    break;
                  default:
                    unitSegmentations.push(
                      SEGMENTATIONS.DIRECT__REHEARSE_STATUS
                    );
                    break;
                }
              }
            }
          }

          if (product) {
            constructionStage = enums.constuctionStages[product.stage];
            const stageSegmentation =
              enums.constuctionStageSegmentation[constructionStage];
            if (
              unitContract &&
              unitContract.keyDeliveryDate &&
              constructionStage === CONSTRUCTION_STAGE.DELIVERED
            ) {
              unitSegmentations.push(
                SEGMENTATIONS.KEYS_DELIVERED__CONSTRUCTION_STAGE
              );
            } else if (stageSegmentation) {
              unitSegmentations.push(stageSegmentation);
            } else {
              unitSegmentations.push(
                SEGMENTATIONS.UNDEFINED__CONSTRUCTION_STAGE
              );
            }
          } else {
            unitSegmentations.push(SEGMENTATIONS.UNDEFINED__CONSTRUCTION_STAGE);
          }
          commit(UNIT.UNIT_SEGMENTATIONS_MUTATE, unitSegmentations);
          console.warn('Segmented Home', unitSegmentations);

          if (unitSegmentations.length) {
            const dataLogTrace = {};
            dataLogTrace[i18n.t('labels.isKeyDeliveredLabel')] = unitContract
              ? i18n.t(`labels.${!!unitContract.keyDeliveryDate}`)
              : null;
            dataLogTrace[i18n.t(`labels.isSettled`)] = unitContract
              ? i18n.t(`labels.${!!unitContract.isSettled}`)
              : null;
            dataLogTrace[i18n.t('labels.constructionStageLabel')] = i18n.t(
              `labels.constructionStage.${constructionStage}`
            );
            dataLogTrace[i18n.t('labels.isRehearseFinishedLabel')] =
              unitContract
                ? i18n.t(`labels.${!!unitContract.isRehearseFinished}`)
                : null;
            dataLogTrace[i18n.t('labels.financialModalityLabel')] =
              unitContract && unitContract.financialModality
                ? unitContract.financialModality
                : null;

            formatObjectuUndefined(dataLogTrace);
            logTrace({
              action: enums.logTraceActions.segmentedHome,
              details: {
                'Home Segmentada': dataLogTrace,
              },
            });
          }

          logTrace({
            action: enums.logTraceActions.controlledLogInfo,
            details: {
              Information: {
                unitSegmentations,
                unitContract,
                constructionStage,
                date: moment(),
                description: "segmentedHome after 'unitSegmentations.length'",
              },
            },
          });
        }
      }

      commit(UNIT.PRODUCT_MUTATE, product);
      return product;
    },

    [UNIT.FETCH_PRODUCT_DETAILS]: async (
      { state, commit, dispatch },
      unitChanged
    ) => {
      let productDetails = null;
      const unitObj = state.unit;
      if (unitObj && unitObj.product) {
        const code = unitObj.product.code;
        const externalSourceId = unitObj.product.id;
        if (
          state.productDetails &&
          state.productDetails.code === code &&
          state.productDetails.externalSourceId === externalSourceId
        ) {
          productDetails = state.productDetails;
        } else {
          const params = {
            filter: {
              code,
              externalSourceId,
            },
            desiredFields: {
              code: 1,
              externalSourceId: 1,
              document: 1,
              links: 1,
              discounts: 1,
              discountKeyDeliveryRequired: 1,
              lastModified: 1,
              isPerformanceStandard: 1,
            },
          };
          const url = `${process.env.CRUD_API_GET}/productDetails`;

          const paramsKey = JSON.stringify(params);
          if (
            !promisesCache[paramsKey] ||
            moment().isAfter(promisesCache[paramsKey].validUntil)
          ) {
            promisesCache[paramsKey] = {
              validUntil: moment().add(5, 'minutes').toISOString(),
              promise: requestService(url, 'GET', {
                params,
              }).catch((err) => {
                delete promisesCache[paramsKey];
                throw err;
              }),
            };
          }

          const result = await promisesCache[paramsKey].promise;
          productDetails =
            result.items && result.items.length > 0 ? result.items[0] : null;
        }
      }
      setItem('productDetails', productDetails);
      commit(UNIT.PRODUCT_DETAILS_MUTATE, productDetails);

      return productDetails || {};
    },

    [UNIT.SYNDIC_PRODUCTS]: async ({ state, commit }, user) => {
      const units = user.products
        .map((p) => {
          const skus = p.sku.split(',');
          const units = skus.map((sku) => {
            const [productId, blockCode, unitCode] = sku.split('-');
            return {
              product: {
                id: p.externalSourceId,
                externalSourceId: p.externalSourceId,
                code: p.code,
                title: p.title,
              },
              block: {
                code: blockCode,
              },
              unit: {
                id: sku,
                code: unitCode,
              },
              sku: sku,
              isValid: true,
              proposers: [
                {
                  id: user._id,
                  document: user.username,
                  name: user.fullName,
                  isMain: true,
                },
              ],
            };
          });
          return units;
        })
        .reduce((a, b) => a.concat(b), []);

      commit(UNIT.MUTATE, units);
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/unit.js